const tiny = {
  plugins: 'link code',
  toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code',
  apiKey: '13nfxoeryypmigsaon21w6e38rns46ra6s39xjn4rjddhid9',
};

export default tiny;
